import Cookies from "js-cookie";

export const getTokenLocal = () => {
  return Cookies.get("x_auth_token_admin-gramin");
};

export const getPermissionLocal = () => {
  const permission = Cookies.get("x_premission_admin_grmin");
  if (permission) {
    return JSON.parse(permission);
  } else {
    return null;
  }
};

export const getUserLocal = () => {
  const user = Cookies.get("x_ufo_admin_gramin");
  if (user !== null && user !== undefined) {
    try {
      if (typeof user === "string" && (user === "[object Object]" || user === "undefined")) {
        return null;
      }
      return typeof user === "string" ? JSON.parse(user) : user;
    } catch (err) {
      console.error("getUserLocal JSON parse error:", err);
      return null;
    }
  } else {
    return null;
  }
};

export const getFranchiseLocal = () => {
  const user = Cookies.get("x_franchise");
  if (user !== null && user !== undefined) {
    try {
      if (typeof user === "string" && (user === "[object Object]" || user === "undefined")) {
        return null;
      }
      return typeof user === "string" ? JSON.parse(user) : user;
    } catch (err) {
      return null;
    }
  } else {
    return null;
  }
};

export const setFranchiseLocal = (user) => {
  const val = typeof user === "object" && user !== null ? JSON.stringify(user) : user;
  Cookies.set("x_franchise", val, { expires: 30 });
};
export const setTokenLocal = (token) => {
  Cookies.set("x_auth_token_admin-gramin", token, { expires: 30 });
};

export const setUserLocal = (user) => {
  const val = typeof user === "object" && user !== null ? JSON.stringify(user) : user;
  Cookies.set("x_ufo_admin_gramin", val, { expires: 30 });
};


export const setPermissionLocal = (user) => {
  Cookies.set("x_premission_admin_grmin", JSON.stringify(user), { expires: 30 });
};

export const clearAuthLocal = () => {
  Cookies.remove("x_auth_token_admin-gramin");
  Cookies.remove("x_auth_token_admin-gramin", { path: "/" });
  Cookies.remove("x_ufo_admin_gramin");
  Cookies.remove("x_ufo_admin_gramin", { path: "/" });
  Cookies.remove("x_franchise");
  Cookies.remove("x_franchise", { path: "/" });
  Cookies.remove("x_premission_admin_grmin");
  Cookies.remove("x_premission_admin_grmin", { path: "/" });
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (e) {
    // ignore
  }
};

let isRedirecting = false;
export const handleSessionExpired = () => {
  if (isRedirecting) return;
  if (typeof window === "undefined") return;

  const pathname = window.location.pathname;
  if (pathname === "/" || pathname === "/login" || pathname === "/forgot-password") {
    clearAuthLocal();
    return;
  }

  isRedirecting = true;
  clearAuthLocal();
  window.location.replace("/");
};
